







import { Component, Vue } from 'vue-property-decorator';
import DirectMessagesThreadsQuery from '@/apollo/queries/DirectMessagesThreads.query';
import { Thread } from '@/types/graphql';
import HeaderDirectMessagesPromo from './HeaderDirectMessagesPromo.vue';
import ChatIcon from './images/chat.vue.svg';

const updateUnreadMessagesInterval = 120000; // 2 mins in ms

@Component<HeaderDirectMessages>({
  name: 'HeaderDirectMessages',
  components: {
    HeaderDirectMessagesPromo,
    ChatIcon,
  },
  apollo: {
    hasUnreadMessages: {
      query: DirectMessagesThreadsQuery,
      update: ({ directMessagesThreads }: { directMessagesThreads: Array<Thread> }) =>
        !!directMessagesThreads.reduce((unreadCount, { unreadMessages }) => unreadCount + unreadMessages, 0),
      pollInterval: updateUnreadMessagesInterval,
      fetchPolicy: 'no-cache',
    },
  },
})
export default class HeaderDirectMessages extends Vue {
  hasUnreadMessages = false;

  get rootStyles() {
    return {
      'header-direct-messages': true,
      'header-direct-messages--unread': this.hasUnreadMessages,
    };
  }

  handleOpen() {
    this.hasUnreadMessages = false;

    this.$modal.showWithRoute('DIRECT_MESSAGES_PROMO_MODAL');
  }
}
